"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasStagedChanges = exports.getCurrentFormSettings = exports.getUpdateFormSettings = void 0;

var _reselect = require("reselect");

var getUpdateFormSettings = function getUpdateFormSettings(state) {
  return state.modules.marketing['form'].staged.updateFormSettings;
};

exports.getUpdateFormSettings = getUpdateFormSettings;

var getCurrentFormSettings = function getCurrentFormSettings(state) {
  return state.modules.marketing['form'].entities.formSettings;
};

exports.getCurrentFormSettings = getCurrentFormSettings;
var getHasStagedChanges = (0, _reselect.createSelector)([getUpdateFormSettings, getCurrentFormSettings], function (stagedSettings, currentSettings) {
  return stagedSettings.some(function (value, key) {
    return stagedSettings.get(key) !== currentSettings.get(key);
  });
});
exports.getHasStagedChanges = getHasStagedChanges;